import type { ComponentProps } from 'react'
import { Alert } from 'ui/src/components/Alert/Alert'
import { CloverIcon } from 'ui/src/icons/CloverIcon'
import { InfoIcon } from 'ui/src/icons/InfoIcon'
import { WarningTriangleIcon } from 'ui/src/icons/WarningTriangleIcon'

export type InfoCardProps = Omit<ComponentProps<typeof Alert.Root>, 'variant'>

export const InfoCard = (props: InfoCardProps) => {
  return (
    <Alert.Root variant="info" {...props}>
      <Alert.Icon icon={InfoIcon} />
      <Alert.Body>
        {typeof props.children === 'string' ? <Alert.Message>{props.children}</Alert.Message> : props.children}
      </Alert.Body>
    </Alert.Root>
  )
}

export const NoticeCard = (props: InfoCardProps) => {
  return (
    <Alert.Root variant="infoInline" {...props}>
      <Alert.Icon icon={InfoIcon} />
      <Alert.Body>
        {typeof props.children === 'string' ? <Alert.Message>{props.children}</Alert.Message> : props.children}
      </Alert.Body>
    </Alert.Root>
  )
}

export const AttentionCard = (props: InfoCardProps) => {
  return (
    <Alert.Root variant="warning" {...props}>
      <Alert.Icon icon={WarningTriangleIcon} />
      <Alert.Body>
        {typeof props.children === 'string' ? <Alert.Message>{props.children}</Alert.Message> : props.children}
      </Alert.Body>
    </Alert.Root>
  )
}

export const ErrorCard = (props: InfoCardProps) => {
  return (
    <Alert.Root variant="error" {...props}>
      <Alert.Icon icon={WarningTriangleIcon} />
      <Alert.Body>
        {typeof props.children === 'string' ? <Alert.Message>{props.children}</Alert.Message> : props.children}
      </Alert.Body>
    </Alert.Root>
  )
}

export const CampaignCard = (props: InfoCardProps) => {
  return (
    <Alert.Root variant="success" {...props}>
      {/* Optical alignment for the clover icon */}
      <Alert.Icon style={{ marginTop: '0.1em' }} icon={CloverIcon} />
      <Alert.Body>
        {typeof props.children === 'string' ? <Alert.Message>{props.children}</Alert.Message> : props.children}
      </Alert.Body>
    </Alert.Root>
  )
}
